
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const neve1073spx: IProductData = {
  id: "neve-1073spx",
  name: "Neve Mic Preamp with EQ",
  description: "The elegantly crafted 1073SPX adopts the 1073® Class A design, exquisite 3-band EQ (fixed HF plus two switchable bands with cut/boost capability) and high pass filter – making the 1073SPX the obvious choice for modern studios.",
  specialOrder: true,
  images: ["/img/neve_1073spx_front.png", "/img/neve_1073spx_back.png"],
  details: [{
    label: "Description",
    markdown: `
The 1073SPX has been shaped to fit into modern 19″ rack format, ubiquitous in today’s studios.

Exclusive Marinair® transformers are used on the microphone input, line input and line output stage, helping to produce that classic Neve 1073® sound.

The 1073SPX retains the discrete, class-A topology made famous by the classic 1073®. Taking this technology forward, the 1073SPX uses a combination of modern production techniques, including our unique, in-house SMT. Still, crucially, the discrete audio path is constructed using through-hole methods, including mounting the Marinair® transformers and class-A transistor-based amplifiers.

The classic 5dB stepped Elma switch delivers accurate gain levels throughout the gain range, and this unique layout means there is no need for a mic/line switch, the pot itself selects the preamp and input. Three distinct gain stages provided by two independent transistor-based preamplifiers provide gain for any DI, line input or microphone signal.

The 1073® preamp produces up to 80dB of microphone gain. By combining multiple gain stages, the 1073SPX input stage delivers the musical drive and harmonic saturation for which the 1073 is famous.

The dedicated instrument DI input mounted to the front of the unit is the ideal way to connect to and record various instruments quickly without having to re-patch microphone cables.

With independent switching of front and rear inputs, the 1073SPX can be integrated into your studio, ready to use as an insert or through a patch bay, with a switchable front combi-connector for recording directly into the front of the unit.

The three-band inductor based EQ is designed for musicality. Rupert and his team of Engineers carefully selected each frequency point to enhance sound quality across the frequency spectrum. The custom hand-wound inductors are made in the Uk and are exclusive to Neve, often exceeding our tight 1073® specification.

Expand your channel strip with the 1073’s balanced, +4dBu insert send/return loop. This circuit gives ultimate flexibility with a switchable pre/post EQ insertion point. Create custom on-the-fly signal flows with any of your favourite outboard processors.

The rotary level pot is your primary channel fader running from -inf to +5, giving plenty of headroom for fine-tuning your recording signal back into the DAW.

For further precision, the 1073SPX features a 7-stage LED meter using PPM ballistics. The LED meter displays signals between -33dB to +24dB at variable points throughout the 1073SPX’s signal chain. Following on, the I/P shows how much gain is added after the preamp stage, and EQ displays overall gain reduction/addition at the inductor EQ stage and O/P displays the final output gain. This is the perfect control over signal flow throughout the unit.
`
  }, {
    label: "Specifications",
    markdown: `
• Genuine 1073® transformer-coupled microphone preamplifier / EQ circuit, in a single 1U 19″ rack-mount enclosure
• Exclusive Neve® Marinair® transformers used on input and output stages
• Convenient connections for Mic, Line & DI inputs on the front of the unit, with switchable mic/line input connections on the rear of the unit
• Switchable +48v Phantom Power, Hi/Lo impedance, -20dB pad and DI ground lift on the input stage
• Switchable Phase and EQ in/out
• Insert send and return loop feature allows external equipment to be connected easily to the 1073SPX audio chain, such as mono limiter/compressors;
• Pre-EQ insert send/return – a line level send is available from the mic-preamp output stage and a return just before the EQ stage
• Post-EQ insert send/return – a line level send is available from the post-EQ stage and a return just before the main output stage
• 7-stage LED signal level meter – can show mic/line/DI input-stage level, EQ-stage level or output-stage level up to +24dB
• Output level control
• External multi-voltage PSU
• Power – 48Vdc, 250mA ±20mA excluding digital module. Negative Earth
`
  }, {
    label: "Preamp Specification",
    markdown: `
• Microphone Input: Gain +80db to +20dB in 5dB steps.
• Line Input: Input impedance 10kΩ, gain +20dB to -10dB in 5dB steps
• DI Input: Input impedance 10M Ohms (PAD off) / 10K Ohms (PAD on) Gain +80dB to +20dB in 5dB steps
`
  }, {
    label: "EQ Specification",
    markdown: `
• High Frequency: Smooth +/-16dB fixed frequency shelving at 12kHz
• Low Frequency: Smooth +/-16dB shelving with selectable frequencies of 35Hz, 60Hz, 110Hz & 220Hz
• Mid Frequency: Smooth +/-18dB peaking, ﬁxed ‘Q’ with selectable centre frequencies of 0.36kHz, 0.7kHz 1.6kHz, 3.2kHz, 4.8kHz & 7.2kHz
• High Pass Filter: 18dB per octave slope, switchable between 50Hz, 80Hz, 160Hz & 300Hz
`
  }, {
    label: "Audio Performance",
    markdown: `
• Output: Maximum output is >+26dBu into 600Ω, transformer balanced and earth free.  – Output Impedance 75Ω @1kHz
• Distortion: Not more than 0.07% from 50Hz to 10kHz at +20dBu output (80kHz bandwidth) into 600Ω.
• Freq Response: ±0.5dB 20Hz to 20kHz, -3dB at 40kHz. EQ Out.
• Noise: -82dBu at all line gain settings (22Hz to 22kHz bandwidth)
• EIN: Better than -125dBu @ 60dB gain.
`
  }, {
  label: "Dimensions",
  markdown: `
• Width: 480mm (19 inches)
• Height: 44mm (1.75 inches)
• Depth: 310mm (12 inches)
• Approx. Weight: 5kg (11 pounds)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.ams-neve.com/outboard/1073spx/" target="_blank">https://www.ams-neve.com/outboard/1073spx/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MICPRE, HASHTAGS.EQ, HASHTAGS.RECORDING, HASHTAGS.LIVE_SOUND, HASHTAGS.ONE_U, HASHTAGS.RACK],
    manufacturer: BRAND.NEVE,
  },
  videos: []
}